import styled from 'styled-components';
import SIDES from './utils/sides';

const getButtonScale = (side, open) => {
    switch (side) {
        case SIDES.LEFT:
            return open ? 'rotateY(0deg)' : 'rotateY(180deg)';
        case SIDES.RIGHT:
            return open ? 'rotateY(180deg)' : 'rotateY(0deg)';
        case SIDES.TOP:
            return open ? 'rotate(90deg) rotateY(0deg)' : 'rotate(90deg) rotateY(180deg)';
        case SIDES.BOTTOM:
            return open ? 'rotate(90deg) rotateY(180deg)' : 'rotate(90deg) rotateY(0deg)';
    }
    return 'rotate(0deg)';
};

export const PanelContainer = styled.div`
  position: absolute;
  transition-duration: .3s;
  padding: 16px;
  box-sizing: content-box;
  button.panel-btn {
    position: absolute;
    width: 24px;
    height: 24px;
    background-color: var(--gameday-background-color);
    border: 1px solid var(--gameday-panel-border-color);
    border-radius: 50%;
    padding: 0px;
    margin: 0px;

    svg {
      box-sizing: border-box;
      padding: 3.5px 4px;
      transition-duration: 0.3s;
      transform-origin: 8px 8px;
      height: 16px;
      width: 16px;
      fill: var(--gameday-panel-button-color);

      path {
        fill: var(--gameday-panel-button-color);
        stroke: var(--gameday-panel-button-color) !important;
        stroke-width: 5px !important;
      }
    }
  }
`;

export const LeftContainer = styled(PanelContainer)`
  left: 0px;
  // subtract padding from top/bottom
  height: calc(100% - 32px);
  width: 375px;
  ${({ open }) => !open ? 'transform: translate(calc(-100% + 16px));' : ''}
  button.panel-btn {
    top: 30px;
    right: auto;
    left: 100%;
    svg {
      transform: ${({ open }) => open ? 'rotateZ(0deg)' : 'rotateZ(180deg)'};
    }
  }
`;

export const RightContainer = styled(LeftContainer)`
  left: auto;
  right: 0px;
  ${({ open }) => !open ? 'transform: translate(calc(100% - 16px));' : ''}
  button.panel-btn {
    left: auto;
    right: 100%;
    svg {
      transform: ${({ open }) => open ? 'rotateZ(180deg)' : 'rotateZ(0deg)'};
    }
  }
`;

export const TopContainer = styled(PanelContainer)`
  top: 0px;
  height:  375px;
  width: 100%;
  ${({ open }) => !open ? 'transform: translateY(calc(-100% + 16px));' : ''}
  button.panel-btn {
    left: calc(50% - 15px);
    top: 100%;
    svg {
      transform: ${({ open }) => open ? 'rotate(90deg) rotateZ(0deg)' : 'rotate(90deg) rotateZ(180deg)'};
    }
  }
`;

export const BottomContainer = styled(TopContainer)`
  bottom: 0px;
  top: auto;
  ${({ open }) => !open ? 'transform: translateY(calc(100% - 16px));' : ''}
  button.panel-btn {
    left: calc(50% - 15px);
    bottom: 100%;
    top: auto;
    svg {
      transform: ${({ open }) => open ? 'rotate(90deg) rotateZ(180deg)' : 'rotate(90deg) rotateZ(0deg)'};
    }
  }
`;

export const PanelWrapper = styled.div`
  margin: 0;
  box-sizing: border-box;
  height: 100%;
  background-color: var(--gameday-background-color);
  box-shadow: 0px 0px .5px rgba(0, 0, 0, 0.25);
  width: 100%;
  border-radius: var(--gameday-border-radius);
  padding: 16px;
  overflow-y: hidden;
  overflow-x: hidden;
  display: flex;
  flex-direction: column;
  position: relative;

  .live-tabs-portal {
    display: flex;
    height: 100%;
  }
`;
